import DiffViewer from "components/shared/DiffViewer";
import { useState } from "react";
import { Button, Modal, Row } from "react-bootstrap";

const ViewDiffPopup = ({ diffData }) => {
  const [showPopup, setShowPopup] = useState(false);


  const closePopup = () => {
    setShowPopup(false);
  }

  return (
    <>
      <Button
        onClick={() => setShowPopup(true)}
      >
        View
      </Button>
      <Modal
        show={showPopup}
        onHide={closePopup}
        backdrop="static"
        keyboard={false}
        centered
        size="md"
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>Diff</Modal.Title> */}
        </Modal.Header>
        <Modal.Body>
          <Row>
            <DiffViewer
              diffData={diffData}
            />
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={closePopup}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ViewDiffPopup;
